import { create } from 'zustand'

/**
 * Состояние WS-соединения — **UI-состояние**, поэтому zustand, а не Query.
 * Нужно ровно для тонкой полоски «переподключение…» (docs/10 §5): данные при
 * этом не сбрасываются.
 */
export type WsStatus = 'idle' | 'connecting' | 'online' | 'reconnecting' | 'offline'

interface ConnectionState {
  status: WsStatus
  /** Причина последнего разрыва — во всплывающей подсказке полоски. */
  lastError: string | null
  setStatus: (status: WsStatus, error?: string | null) => void
}

export const useConnectionStore = create<ConnectionState>(set => ({
  status: 'idle',
  lastError: null,
  setStatus: (status, error = null) => set({ status, lastError: error })
}))
